










































import { Component, Inject, Vue } from "vue-property-decorator";
import { container } from "@/services/registerServiceProvider";
import { IStoreService } from "@/services/IStoreService";
import { Location } from "vue-router";
import HomeMenuCard from "@/components/HomeMenuCard.vue";
import { IUserRoleService } from "@/services/IUserRoleService";
import HomeSalesStatistics from "@/components/HomeSalesStatistics.vue";
import HomeOrderReports from "@/components/HomeOrderReports.vue";
import HomeNews from "@/components/HomeNews.vue";
import {IHttpService} from "frontend-core";

@Component({
  components: { HomeNews, HomeOrderReports, HomeSalesStatistics, HomeMenuCard },
})
export default class HomePage extends Vue {
  @Inject()
  public readonly storeService!: IStoreService;


  private readonly httpService: IHttpService = container.resolve("IHttpService");

  advisorTitle: string = "Советник";
  advisorIcon: string = "fa-question-circle";

  homeMenu: HomeMenu[] = [
    {
      link: { name: "segmentation-search" },
      title: "Поиск агентов",
      subtitle: "Поиск и&nbsp;просмотр данных по&nbsp;агентам",
      icon: "fa-search",
      drawLink: true,
    },
    {
      link: {
        name: "segmentation-report",
        params: { agentId: this.storeService.currentAgent?.id || "" },
      },
      title: "Просмотр сегментации",
      subtitle: "Посмотреть свою сегментацию и&nbsp;своих агентов",
      icon: "fa-book-open",
      drawLink: !this.isUserHasChangeParentRole && container.resolve<IUserRoleService>("IUserRoleService")
          .isAllowSegmentationRead,
    },
    {
      link: {
        name: "segmentation-editor",
        params: { agentId: this.storeService.currentAgent?.id || "" },
      },
      title: "Изменение сегментации",
      subtitle:
        "Редактировать свою сегментацию и&nbsp;сегментацию своих агентов",
      icon: "fa-edit",
      drawLink:
        container.resolve<IUserRoleService>("IUserRoleService")
          .isAllowSegmentationEdit && !this.isUserHasChangeParentRole,
    },
    {
      link: {
        name: "agent-dashboard",
        params: { id: this.storeService.currentAgent?.id || "" },
      },
      title: "Профиль",
      subtitle:
        "Настроить свою почту для&nbsp;согласований антисегементных договоров",
      icon: "fa-user",
      drawLink: true,
    },
  ];

  get isShowLogBtn(): boolean {
    return this.storeService.currentAgent ? container.resolve<IUserRoleService>("IUserRoleService")
      .isUserAdmin(this.storeService.currentAgent?.user) : false;
  }

  get isUserHasChangeParentRole(): boolean {
    return container.resolve<IUserRoleService>("IUserRoleService")
      .isHasChangeParentRole;
  }

  async getLog() {
    const file: Blob = (await this.httpService.api.get('log_curator/report', { responseType: "blob" })).data;
    const a = document.createElement('a');

    a.href = URL.createObjectURL(file);
    a.download = `log.xlsx`;
    a.click()
  }
}

type HomeMenu = Readonly<{
  link: string | Location;
  title: string;
  subtitle: string;
  icon: string;
  drawLink: boolean;
}>;
